import "./index.sass";
import { useSelector } from "react-redux";
import store from "src/Reducers/store";

const HeaderRight = () => {
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);

  return <div className="header-right">{currentPage > 5 && currentPage !== 9 ? "Powered by Infosys Telco Insights Solution" : ""}</div>;
};

export default HeaderRight;
